import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { PreSaleBanner } from '../components/layout/PreSaleBanner';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { SEO } from '../components/SEO';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FlowBackground } from '../components/home/FlowBackground';
import { PAGE_BG } from '../components/home/glass';

function FAQItem({ item, isOpen, onToggle }) {
    return (
        <div className="border border-border rounded-xl overflow-hidden">
            <button
                onClick={onToggle}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-accent transition-colors"
                aria-expanded={isOpen}
            >
                <span className="font-semibold text-foreground text-[15px] pr-4">{item.q}</span>
                <ChevronDown
                    size={18}
                    className={`text-muted-foreground shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>
            <motion.div
                initial={false}
                animate={{ height: isOpen ? 'auto' : 0, opacity: isOpen ? 1 : 0 }}
                transition={{ duration: 0.25 }}
                className="overflow-hidden"
            >
                <p className="px-5 pb-5 text-sm text-muted-foreground leading-relaxed">{item.a}</p>
            </motion.div>
        </div>
    );
}

export default function FAQ() {
    const { t } = useLanguage();
    const [openIdx, setOpenIdx] = useState(null);
    const items = t('faq.items');

    return (
        <div>
            <SEO
                title="FAQ | Sleepstack"
                description="Common questions about ordering, the pre-sale, ingredients, refunds, and delivery."
                path="/faq"
            />
            <PreSaleBanner />
            <Navbar />
            <main className="relative isolate glass-scope" style={{ paddingTop: 'var(--page-offset, 128px)', background: PAGE_BG }}>
                <FlowBackground variant="faq" />
                <section className="section-padding bg-white">
                    <div className="section-container max-w-2xl">
                        <h1 className="sr-only" data-testid="faq-title">{t('faq.title')}</h1>

                        <div className="space-y-3">
                            {Array.isArray(items) && items.map((item, i) => (
                                <motion.div
                                    key={i}
                                    initial={{ opacity: 0, y: 12 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.35, delay: i * 0.05 }}
                                >
                                    <FAQItem
                                        item={item}
                                        isOpen={openIdx === i}
                                        onToggle={() => setOpenIdx(prev => prev === i ? null : i)}
                                    />
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
